<template lang='pug'>
  r-table(
    loading-text='Cargando ofertas...'
    no-data-text='Sin ofertas.'
    no-detail
    no-search
    ref='table'
    remind-key='sl-grouped-offer-list'
    toolbar-dense
    v-bind='tableProps'
    @detail='submitDetail'
    @remove='submitDelete'
    )
    template(slot="actions" slot-scope="props")
      v-btn(
          color='amber darken-2'
          flat
          icon
          @click='$router.push(`/offer/${props.item.id}`)'
          v-if="$can('EDIT_SALE_OFFER')"
          )
          v-icon edit
    template( slot='items' )
      r-dialog(
        content-class='grey lighten-3'
        no-confirm
        v-bind='dialogProps'
        v-model='dialog'
        )
        r-form( 
          class='white'
          no-submit
          reset-text='refrescar'
          v-bind='formProps' 
          v-model='selected'
          @reset='submitReset'
          )
      GroupedDetailModal(
        v-model="activeModal"
        :offer-id="activeId"
        )
</template>

<script>
  //
  import { RDialog, RForm, RTable } from '@/components/reusable_components/next'
  import GroupedDetailModal from './GroupedDetailModal'
  import { mapActions } from 'vuex'
  import groupedOfferService from '../../services/api/offer/groupedOfferService'
  import headers from './groupedListHeaders'
  import filters from './filters'
  //
  import SlGroupedOfferFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferFields'
  import SlGroupedOfferFilters from '@/views/Sale/SlGroupedOffer/SlGroupedOfferFilters'
  import SlGroupedOfferHeaders from '@/views/Sale/SlGroupedOffer/SlGroupedOfferHeaders'
  import SlGroupedOfferService from '@/services/api/Sale/SlGroupedOffer'
  //
  export default {
    components: {
      RDialog,
      RForm,
      RTable,
      GroupedDetailModal,
    },
    computed: {
      dialogProps() {
        return {
          title: `Detalle de oferta masiva: ${this.selected ? this.selected.name : ''}`
        }
      },
      formProps() {
        return {
          fields: SlGroupedOfferFields,
        }
      },
      tableProps() {
        return {
          filters: SlGroupedOfferFilters,
          headers: SlGroupedOfferHeaders,
          service: SlGroupedOfferService.toList(),
        }
      }
    },
    data () {
      return {
        dialog: false,
        selected: null,
      }
    },
    methods: {
      genGroupedOfferDelete() {
        return {
          sl_offers: this.selected.sl_offers.map(this.mapGroupedOfferDelete)
        }
      },
      mapGroupedOfferDelete(item) {
        return item.id
      },
      refresh() {
        this.$refs.table.refresh()
      },
      showSuccessDelete() {
        this.showSuccessSnackbar('Oferta eliminada exitosamente.')
      },
      submitDelete(event) {
        this.showWarningSnackbar({
          title: '¿Desea eliminar la oferta selecciona?',
          message: 'Una vez eliminada no se puede recuperar.',
          confirm: 'eliminar',
        })
        this.selected = event.item
      },
      showModal(itm) {
        this.activeId = itm.item.id
        this.activeModal = true
      },
      submitDetail(event) {
        this.dialog = true
        this.selected = event.item
      },
      submitReset() {
        
      },
      toDelete() {
        groupedOfferService
          .remove(this.genGroupedOfferDelete())
          .then(this.showSuccessDelete)
          .then(this.refresh)
          .catch(this.showErrorSnackbar)
      },
      toError(error) {
        this.showErrorSnackbar(error.response.data.error)
      },
      ...mapActions('MenuesModule', {
          setTitleTopBar: 'setTitleTopBar',
      }),
    },
    watch: {
      responseConfirmSnackbar(value) {
        switch(value) {
          case 'eliminar': return this.toDelete()
        }
      },
    },
    created() {
      this.setTitle('Listado de ofertas masivas')
      this.$setItemsTopBar([
        {
          text: 'crear oferta masiva',
          icon: 'add',
          can: 'CREATE_SALE_OFFER',
          action: () => this.$router.push('/offer/create'),
        },
      ])
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_SALE_OFFER')) ctx.$router.push('/')
      })
    },
  }
</script>
